module.exports = __webpack_public_path__ + "img/def-cover-1.3c274063.jpg";